import { render, staticRenderFns } from "./ProtectedDoc_Form.vue?vue&type=template&id=272e48cf&scoped=true&"
import script from "./ProtectedDoc_Form.vue?vue&type=script&lang=js&"
export * from "./ProtectedDoc_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272e48cf",
  null
  
)

export default component.exports